<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Selecione e aplique os filtros</h4>
    <button
      type="button"
      class="close"
      data-bs-dismiss="modal"
      aria-label="Close"
      (click)="onClose()"
    >
      <img
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/icon-close.png"
        alt=""
      />
    </button>
  </div>
  <div class="modal-body">
    <div class="filtros">
      <div class="col-md-4 tipos-de-filtros-modal">
        <ul>
          <li
            (click)="selecionarAba('detalhesApartamento')"
            [class.active]="this.abaSelecionada == 'detalhesApartamento'"
          >
            Detalhes do Apartamento
          </li>
          <li
            (click)="selecionarAba('detalhesCobertura')"
            [class.active]="this.abaSelecionada == 'detalhesCobertura'"
          >
            Detalhes da Cobertura
          </li>
          <li
            (click)="selecionarAba('detalhesEmp')"
            [class.active]="this.abaSelecionada == 'detalhesEmp'"
          >
            Detalhes do empreendimento
          </li>
          <li
            (click)="selecionarAba('areasComuns')"
            [class.active]="this.abaSelecionada == 'areasComuns'"
          >
            Áreas Comuns
          </li>
        </ul>
      </div>

      <div class="col-md-8 filtros-modal">
        <div class="resultado">
          <!-- Detalhes do Apartamento -->
          <div
            *ngIf="abaSelecionada === 'detalhesApartamento'"
            class="detalhes-apartamento"
          >
            <ul class="grid-container">
              <li
                *ngFor="let option of filtro_DetalhesApto"
                class="checkbox-item"
              >
                <div class="form-check">
                  <input
                    type="checkbox"
                    name="checkbox"
                    class="form-check-input checkbox"
                    [id]="option['id']"
                    (change)="checkFiltro($event, option)"
                    [(ngModel)]="option['checked']"
                  />
                  <label class="form-check-label" [for]="option['id']">
                    {{ option["alias"] }}
                  </label>
                </div>
              </li>
            </ul>
          </div>


          <!-- Detalhes do Empreendimento -->
          <div *ngIf="abaSelecionada === 'detalhesEmp'" class="detalhes-Emp">
            <ul class="li-detalhe row">
              <!-- Filtro Unidades -->
              <li>
                <span class="filterLabel">Unidades:</span>
                <span
                  >De:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'unidadesDe')
                    "
                    name="optUnidadesObraDe"
                    class="selectMiniItem"
                    id="optUnidadesObraDe"
                    [(ngModel)]="unidadesDeSelecionado"
                  >
                    <option [value]="'0'">Indiferente</option>
                    <option
                      *ngFor="let data of dataUnidadesDe"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
                <span
                  >Até:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'unidadesAte')
                    "
                    name="optUnidadesObraAte"
                    class="selectMiniItem"
                    id="optUnidadesObraAte"
                    [(ngModel)]="
                      ateSelecionadoDefaults['unidadesAteSelecionado']
                    "
                  >
                    <option [value]="999999999">Indiferente</option>
                    <option
                      *ngFor="let data of dataUnidadesAte"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
              </li>
              <!-- Filtro Blocos -->
              <li>
                <span class="filterLabel">Blocos:</span>
                <span
                  >De:
                  <select
                    (change)="onSelectChangeEmpreendimento($event, 'blocosDe')"
                    name="optBlocosDe"
                    class="selectMiniItem"
                    id="optBlocosDe"
                    [(ngModel)]="blocosDeSelecionado"
                  >
                    <option [value]="'0'">Indiferente</option>
                    <option
                      *ngFor="let data of dataBlocosDe"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
                <span
                  >Até:
                  <select
                    (change)="onSelectChangeEmpreendimento($event, 'blocosAte')"
                    name="optBlocosAte"
                    class="selectMiniItem"
                    id="optBlocosAte"
                    [(ngModel)]="ateSelecionadoDefaults['blocosAteSelecionado']"
                  >
                    <option [value]="999999999">Indiferente</option>
                    <option
                      *ngFor="let data of dataBlocosAte"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
              </li>

              <!-- Filtro Pavimentos -->
              <li>
                <span class="filterLabel">Pavimentos:</span>
                <span
                  >De:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'pavimentosDe')
                    "
                    name="optPavimentosDe"
                    class="selectMiniItem"
                    id="optPavimentosDe"
                    [(ngModel)]="pavimentosDeSelecionado"
                  >
                    <option [value]="0">Indiferente</option>
                    <option
                      *ngFor="let data of dataPavimentosDe"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
                <span
                  >Até:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'pavimentosAte')
                    "
                    name="optPavimentosAte"
                    class="selectMiniItem"
                    id="optPavimentosAte"
                    [(ngModel)]="
                      ateSelecionadoDefaults['pavimentosAteSelecionado']
                    "
                  >
                    <option [value]="999999999">Indiferente</option>
                    <option
                      *ngFor="let data of dataPavimentosAte"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
              </li>

              <!-- Área Total -->
              <li>
                <span class="filterLabel">Área total:</span>
                <span
                  >De:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'areaTotalDe')
                    "
                    name="optAreaUtilTotalDe"
                    class="selectMiniItem"
                    id="optAreaUtilTotalDe"
                    [(ngModel)]="areaTotalDeSelecionado"
                  >
                    <option [value]="0">Indiferente</option>
                    <option
                      *ngFor="let data of dataAreaTotalDe"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
                <span
                  >Até:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'areaTotalAte')
                    "
                    name="optAreaUtilTotalAte"
                    class="selectMiniItem"
                    id="optAreaUtilTotalAte"
                    [(ngModel)]="
                      ateSelecionadoDefaults['areaTotalAteSelecionado']
                    "
                  >
                    <option [value]="999999999">Indiferente</option>
                    <option
                      *ngFor="let data of dataAreaTotalAte"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
              </li>

              <!-- M² unidade -->
              <li>
                <span class="filterLabel">M² unidade:</span>
                <span
                  >De:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'metroQuadradoDe')
                    "
                    name="optAreaMediaDe"
                    class="selectMiniItem"
                    id="optAreaMediaDe"
                    [(ngModel)]="metroQuadradoDeSelecionado"
                  >
                    <option [value]="0">Indiferente</option>
                    <option
                      *ngFor="let data of dataMetroQuadradoDe"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
                <span
                  >Até:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'metroQuadradoAte')
                    "
                    name="optAreaMediaAte"
                    class="selectMiniItem"
                    id="optAreaMediaAte"
                    [(ngModel)]="
                      ateSelecionadoDefaults['metroQuadradoAteSelecionado']
                    "
                  >
                    <option [value]="999999999">Indiferente</option>
                    <option
                      *ngFor="let data of dataMetroQuadradoAte"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
              </li>

              <!-- Banheiros -->
              <li>
                <span class="filterLabel">Banheiros:</span>
                <span
                  >De:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'banheirosDe')
                    "
                    name="optBanheirosDe"
                    class="selectMiniItem"
                    id="optBanheirosDe"
                    [(ngModel)]="banheirosDeSelecionado"
                  >
                    <option [value]="0">Indiferente</option>
                    <option
                      *ngFor="let data of dataBanheirosDe"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
                <span
                  >Até:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'banheirosAte')
                    "
                    name="optBanheirosAte"
                    class="selectMiniItem"
                    id="optBanheirosAte"
                    [(ngModel)]="
                      ateSelecionadoDefaults['banheirosAteSelecionado']
                    "
                  >
                    <option [value]="999999999">Indiferente</option>
                    <option
                      *ngFor="let data of dataBanheirosAte"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
              </li>

              <!-- Vagas -->
              <li>
                <span class="filterLabel">Vagas:</span>
                <span
                  >De:
                  <select
                    (change)="onSelectChangeEmpreendimento($event, 'vagasDe')"
                    name="optVagasAte"
                    class="selectMiniItem"
                    id="optVagasAte"
                    [(ngModel)]="vagasDeSelecionado"
                  >
                    <option [value]="0">Indiferente</option>
                    <option
                      *ngFor="let data of dataVagasDe"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
                <span
                  >Até:
                  <select
                    (change)="onSelectChangeEmpreendimento($event, 'vagasAte')"
                    name="optVagasDe"
                    class="selectMiniItem"
                    id="optVagasDe"
                    [(ngModel)]="ateSelecionadoDefaults['vagasAteSelecionado']"
                  >
                    <option [value]="999999999">Indiferente</option>
                    <option
                      *ngFor="let data of dataVagasAte"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
              </li>
              <!-- Dormitorios -->
              <li>
                <span class="filterLabel">Dormitórios:</span>
                <span
                  >De:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'dormitoriosDe')
                    "
                    name="optDormitoriosDe"
                    class="selectMiniItem"
                    id="optDormitoriosDe"
                    [(ngModel)]="dormitoriosDeSelecionado"
                  >
                    <option [value]="0">Indiferente</option>
                    <option
                      *ngFor="let data of dataDormitoriosDe"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
                <span
                  >Até:
                  <select
                    (change)="
                      onSelectChangeEmpreendimento($event, 'dormitoriosAte')
                    "
                    name="optDormitoriosAte"
                    class="selectMiniItem"
                    id="optDormitoriosAte"
                    [(ngModel)]="
                      ateSelecionadoDefaults['dormitoriosAteSelecionado']
                    "
                  >
                    <option [value]="999999999">Indiferente</option>
                    <option
                      *ngFor="let data of dataDormitoriosAte"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
              </li>

              <li>
                <span class="filterLabel">Suítes:</span>
                <span
                  >De:
                  <select
                    (change)="onSelectChangeEmpreendimento($event, 'suitesDe')"
                    name="optSuitesDe"
                    class="selectMiniItem"
                    id="optSuitesDe"
                    [(ngModel)]="suitesDeSelecionado"
                  >
                    <option [value]="0">Indiferente</option>
                    <option
                      *ngFor="let data of dataSuitesDe"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
                <span
                  >Até:
                  <select
                    (change)="onSelectChangeEmpreendimento($event, 'suitesAte')"
                    name="optSuitesAte"
                    class="selectMiniItem"
                    id="optSuitesAte"
                    [(ngModel)]="ateSelecionadoDefaults['suitesAteSelecionado']"
                  >
                    <option [value]="999999999">Indiferente</option>
                    <option
                      *ngFor="let data of dataSuitesAte"
                      [value]="data['id']"
                    >
                      {{ data["description"] }}
                    </option>
                  </select>
                </span>
              </li>
            </ul>
          </div>

          <!-- Detalhes da Cobertura -->
          <div
            *ngIf="abaSelecionada === 'detalhesCobertura'"
            class="detalhes-cobertura"
          >
            <ul class="grid-container">
              <li
                *ngFor="let option of filtro_DetalhesCobertura"
                class="checkbox-item"
              >
                <div class="form-check">
                  <input
                    type="checkbox"
                    name="checkbox"
                    class="form-check-input checkbox"
                    [id]="option['id']"
                    (change)="checkFiltro($event, option)"
                    [(ngModel)]="option['checked']"
                  />

                  <label class="form-check-label" [for]="option['id']">
                    {{ option["alias"] }}
                  </label>
                </div>
              </li>
            </ul>
          </div>

          <!-- Áreas Comuns -->
          <div *ngIf="abaSelecionada === 'areasComuns'" class="areas-comuns">
            <ul class="grid-container">
              <li
                *ngFor="let option of filtroAreasComuns"
                class="checkbox-item"
              >
                <div class="form-check">
                  <input
                    type="checkbox"
                    name="checkbox"
                    class="form-check-input checkbox"
                    [id]="option['id']"
                    (change)="checkFiltro($event, option)"
                    [(ngModel)]="option['checked']"
                  />

                  <label class="form-check-label" [for]="option['id']">
                    {{ option["description"] }}
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer custom-modal-footer">
      <div class="limpar-filtros">
        <button type="button" (click)="limparFiltros()">LIMPAR</button>
      </div>
      <button type="button" class="btn btn-primary" (click)="aplicarFiltros()">
        <img
          src="{{
            BASE_IMG_URL
          }}assets/filtro-lateral-busca/button-contained.webp"
          alt=""
          width="89"
          height="36"
        />
      </button>
    </div>
  </div>
</div>
